import { useCallback, useEffect, useState } from 'react';

import { useApi } from '@app/hooks';

export const useEquipmentList = () => {
  const [equipments, setEquipments] = useState<EntityBase[]>([]);
  const api = useApi();

  const fetchEquipments = useCallback(async ({ distributor_id, outlet_id }: {
    distributor_id?: string,
    outlet_id?: string,
  }) => {
    const response = await api.equipments.getEquipments({ 
      filter: {
        ...(distributor_id ? { distributor_id } : {}),
        ...(outlet_id ? { outlet_id } : {}),
      },
      sort: '+id',
      limit: 100000,
      offset: 0,
    });
    if (response.code === 200) {
      setEquipments(response.data.data || []);
    }
  }, [api]);

  return {
    equipments,
    fetchEquipments
  };
};